/**
 * Created by rathompson on 5/24/22
 * File: AuthContext
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { createContext } from 'react'

interface IAuthContext {
  [key: string]: any
}

const context: IAuthContext = {
  auth: {},
  user: {}
}

const AuthContext = createContext(context)

export default AuthContext
